import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/CategoryHeader/index.js";
const variants = import.meta.webpackContext("/components/CategoryHeader", { recursive: true, regExp: /\.\/__variants__\/plp\-featured\-header\/v2\/index\.js/ });
export default pointCut({ joinPoint, variants });